// Swup
import Swup from "swup";
import SwupJsPlugin from '@swup/js-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
// GSAP
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// Modules
import { commonPageOut, commonPageIn } from './transitionAnimation';
import { LenisManager } from '../utils/LenisManager';
import { initScripts } from '../utils/initScripts';
import { SwupGA4 } from "./swupGA4";

/**
 * ViteのDevモードかを判定
 * isDevの真偽値でSwupHeadPluginの有効/無効を切り替え
 */
const isDev = import.meta.env.DEV;

export const pageTransition = () => {
  // Lenis Setup
  const lenisManager = LenisManager.getInstance();
  const lenis = lenisManager.getLenis();
  // Analysis Setup
  const swupGA4 = new SwupGA4();

  let cleanupFunctions: (() => void)[] = []; // AlpineJSを使用しない場合のクリーンアップ関数を入れる箱

  const containers = ["#swup"];
  // WPログイン時、遷移するタイミングでWPツールバーも更新する
  if (document.querySelector("#wpadminbar")) containers.push("#wpadminbar");

  /**
   * Swup初期化
   */
  const swup = new Swup({
    /**
     * 除外処理
     * containers - 遷移時に更新するDOM要素
     * ignoreVisit - 遷移時に除外するURLの定義
     */
    containers,
    ignoreVisit: (url, { el } = {}) => {
      if (!el) return false;
      if (el.closest('[data-no-swup]')) return true;
      if (url.includes('/contact') || url.includes('/contact/complete')) {
        return true;
      }
      // WP管理ページは除外
      if (
        url.includes("/wp-admin/") ||
        url.includes("customize.php")
      ) return true;
      return false;
    },
    /**
     * Plugins
     * SwupJsPlugin - 遷移アニメーションをJSで定義
     */
    plugins: [
      new SwupJsPlugin({
        animations: [
          // 共通アニメーション
          {
            from: '(.*)',
            to: '(.*)',
            out: async () => {
              await commonPageOut();
            },
            in: async () => {
              await commonPageIn();
            }
          }]
      }),
      new SwupHeadPlugin({
        persistAssets: isDev,
      }),
    ]
  });

  // 元ページ退出直前
  swup.hooks.on('animation:out:end', () => {
    if (cleanupFunctions.length > 0) {
      cleanupFunctions.forEach((cleanup) => cleanup());
      cleanupFunctions = [];
    }
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  });
  // Script初期化やDOM操作などはこのタイミングで行う
  swup.hooks.on('page:view', () => {
    lenis.resize();
    lenis.scrollTo(0, { immediate: true }); // Topの即時反映
    cleanupFunctions = initScripts();

    swupGA4.setSendPageView();
  });
  // 新ページ遷移アニメーション完了時
  swup.hooks.on('animation:in:end', () => {
    ScrollTrigger.refresh();
  });
};
